import React from 'react';
import { TextButton } from '@oneaudi/unified-web-components';
import { usePostData } from '../CTA';
import { openFocusLayerV2 } from '../../../../../components/layer/FocusLayerV2';
import { dynamicStylingHelper } from '../../../../utils/AlphaHelper';
const NewLayerButton = ({ buttonInfo, variant, layerManager, trackButtonClick, configurationService, isMobileScreenSize, isLoading, vehicle, }) => {
    var _a, _b;
    const iframeForms = ((_a = configurationService === null || configurationService === void 0 ? void 0 : configurationService.getConfiguration()) === null || _a === void 0 ? void 0 : _a.scopes.iframeForms) || false;
    const postData = usePostData(vehicle, buttonInfo.dataProfile);
    const { label, type } = buttonInfo;
    return (React.createElement(TextButton, { "aria-label": (_b = buttonInfo.ariaLabel) !== null && _b !== void 0 ? _b : label, variant: variant, "data-testid": `${type}-button-variant-${variant}`, "data-tracking-exclude": true, isFullWidth: isMobileScreenSize, isLoading: isLoading, onClick: () => {
            trackButtonClick(buttonInfo, variant, buttonInfo.trackingCode);
            openFocusLayerV2(buttonInfo, postData, layerManager, iframeForms);
        }, size: dynamicStylingHelper('md', 'sm') }, label));
};
export default NewLayerButton;
